import { usePrimitiveT } from "../i18n/I18nProvider.tsx";
import { Button } from "./Button.tsx";
import { Icon } from "./Icon.tsx";
import { Logo } from "./Logo.tsx";

export type AppBannerProps = {
  /** "Bundle". */
  title: string;
  /** "Mail, chat and calls work better in the app." */
  message: string;
  /** The store line: "Free on the App Store", "Direct download (.apk)". */
  store: string;
  /** "Get" / "Install" / "Download". */
  action: { label: string; onPress: () => void; testID: string };
  onDismiss: () => void;
  /** Name of the close button (default "Dismiss"). */
  dismissLabel?: string;
  testID: string;
};

/**
 * The app-store style prompt a phone or tablet browser shows above the web app (design system: AppBanner). Close,
 * the app tile, title / message / store line and a pill action. Pushes content down; never floats over it.
 */
export function AppBanner({ title, message, store, action, onDismiss, dismissLabel, testID }: AppBannerProps) {
  const t = usePrimitiveT();
  return (
    <div className="b-app-banner" role="region" aria-label={title} data-testid={testID}>
      <button type="button" className="b-icon-button b-icon-button-ghost b-app-banner-close" aria-label={dismissLabel ?? t("common.dismiss")} onClick={onDismiss} data-testid={`${testID}-dismiss`}>
        <Icon name="close" size="icon.sm" />
      </button>
      <Logo variant="tile" size="appTile" />
      <span className="b-app-banner-text">
        <span className="b-app-banner-title">{title}</span>
        <span className="b-app-banner-message">{message}</span>
        <span className="b-app-banner-store">{store}</span>
      </span>
      <Button label={action.label} onPress={action.onPress} variant="primary" size="md" testID={action.testID} />
    </div>
  );
}
